import {
    asyncPagedActionCreator,
    asyncActionCreator,
    valueHolderActionCreator,
} from './../../shared/redux/actions/common'
import {
    FETCH_LIST_LOCATIONS,
    FETCH_MAP_LOCATIONS,
    FETCH_LOCATION_DETAIL,
    MAP_TOKEN,
    UPDATE_LOCATION_INFO,
    UPDATE_CONNECTOR_STATUS_LOCATION_DETAIL,
} from '../const'
import { getJson } from '../../shared/utils/api'
import { ChargerConnectorSocketType } from '../../shared/types/charger'
import { Coordinates } from '../../shared/types/common'

export const fetchListLocations = (
    key: any,
    state: any,
    pageNumber?: number,
    filter?: {
        search?: string
        availability?: boolean
        distance?: { km?: number; location: Coordinates }
        connector?: ChargerConnectorSocketType
        showHiddenLocation?: boolean
        sortByDistance?: boolean
        TenantIds?: string[] // Toto už máš správne
    }
) => {
    const sort = filter?.sortByDistance ? 'distanceInMeters asc' : 'name asc'

    // 1. Získame základné query parametre z tvojho buildQuery
    let query = buildQuery(filter)

    // 2. Ručne pridáme TenantIds do query stringu vo formáte TenantIds=id1&TenantIds=id2
    if (filter?.TenantIds && filter.TenantIds.length > 0) {
        const tenantQuery = filter.TenantIds.map((id) => `TenantIds=${encodeURIComponent(id)}`).join('&')

        // Pridáme k existujúcemu query, postrážime si ampersand
        query += (query ? '&' : '') + tenantQuery
    }

    let url = `locations?${query}`

    // Zabezpečíme, aby medzi url a ďalšími parametrami bol správny znak (? alebo &)
    const joinChar = url.includes('?') ? '&' : '?'

    return asyncPagedActionCreator(
        FETCH_LIST_LOCATIONS,
        (pageIndex, pageSize) => getJson(url + `${joinChar}page=${pageIndex}&pageSize=100&sort=${sort}`),
        key,
        state,
        pageNumber
    )
}

/*export const updateChargingSessionLocationDetail = (locationInfo: any) => ({
    type: UPDATE_CHARGING_SESSION_LOCATION_DETAIL,
    payload: {
        locationInfo: locationInfo,
    },
})*/

export const updateConnectorStatusLocationDetail = (locationInfo: any) => ({
    type: UPDATE_CONNECTOR_STATUS_LOCATION_DETAIL,
    payload: {
        locationInfo: locationInfo,
    },
})

export const updateLocationInfo = (locationInfo: any) => ({
    type: UPDATE_LOCATION_INFO,
    payload: {
        locationInfo: locationInfo,
    },
})

export const fetchMapLocations = (filter?: {
    search?: string
    availability?: boolean
    distance?: { km?: number; location: Coordinates }
    connector?: ChargerConnectorSocketType
    showHiddenLocation?: boolean
    TenantIds?: string[]
}) => {
    let url = `locations/all?${buildQuery(filter)}`

    return asyncActionCreator(FETCH_MAP_LOCATIONS, () => getJson(url))
}

export const fetchLocationDetail = (locationId: string) => {
    return asyncActionCreator(FETCH_LOCATION_DETAIL, () => getJson(`locations/${locationId}`))
}

export const setMapToken = (token: string) => {
    return valueHolderActionCreator(MAP_TOKEN, token)
}

const buildQuery = (filter?: {
    search?: string
    availability?: boolean
    distance?: { km?: number; location: Coordinates }
    connector?: ChargerConnectorSocketType
    showHiddenLocation?: boolean
    TenantIds?: string[]
}) => {
    let query = ''
    if (filter) {
        if (filter.search) {
            query += `searchQuery=${filter.search}&`
        }
        if (filter.distance?.km) {
            query += `distanceInMeters=${filter.distance.km * 1000}&`
        }
        if (filter.distance?.location) {
            query += `latitude=${filter.distance.location.lat}&longitude=${filter.distance.location.lng}&`
        }
        if (filter.connector != null) {
            query += `socketType=${filter.connector}&`
        }
        if (filter.TenantIds && filter.TenantIds.length > 0) {
            filter.TenantIds.forEach((id) => {
                query += `TenantIds=${encodeURIComponent(id)}&`
            })
        }
        query += `onlyAvailable=${filter.availability}&`
        if (filter.showHiddenLocation === undefined) {
            filter.showHiddenLocation = false
        }
        query += `showHidden=${filter.showHiddenLocation}&`
    }
    return query
}
